<template>
  <sp-fieldset flex rowgap="1">
    <sp-row justify="space-between">
      <sp-col>
        <sp-label>Background Color</sp-label>
        <sp-theme-color-picker :value="model.color" @update-model-value="handleUpdateColor"></sp-theme-color-picker>
      </sp-col>
    </sp-row>
  </sp-fieldset>
</template>

<script setup>
import { computed } from "vue";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function handleUpdateColor({ detail }) {
  const [value] = detail;
  model.value.color = value;
}
</script>

<style lang="scss" scoped>
sp-theme-color-picker {
  margin-top: var(--sp-ref-scale-4);
}
</style>
